"use client";

import { useEffect } from "react";
import { TarotRequestCreate } from "@/types/tarot";
import { useI18n } from "@/i18n/I18nProvider";

interface Step3ChanneledPersonProps {
  formData: TarotRequestCreate;
  fieldErrors: Set<string>;
  onInputChange: (
    field: string,
    value: string | boolean | Record<string, string | boolean> | null
  ) => void;
  onFieldErrorRemove: (field: string) => void;
}

export function Step3ChanneledPerson({
  formData,
  fieldErrors,
  onInputChange,
  onFieldErrorRemove,
}: Step3ChanneledPersonProps) {
  const { t } = useI18n();

  useEffect(() => {
    if (!(formData.channeled_person.zodiac_sign || "").trim()) {
      onInputChange("channeled_person.zodiac_sign", "Não sei");
    }
  }, [formData.channeled_person.zodiac_sign, onInputChange]);

  return (
    <div className="space-y-3">
      <div className="bg-white/50 rounded-lg p-3 border border-[rgba(232,115,115,0.2)] mb-3">
        <div className="flex items-center space-x-2">
          <div className="text-xl">💫</div>
          <p className="form-description-text">
            <span className="font-title">
              {t("step3.header.title", "Pessoa Canalizada:")}
            </span>{" "}
            {t(
              "step3.header.desc",
              "A pessoa cujos sentimentos e pensamentos serão canalizados na carta."
            )}
          </p>
        </div>
      </div>

      <div>
        <label className="form-label-compact">
          {t("step3.full_name.label", "Nome da Pessoa Canalizada *")}
        </label>
        <input
          type="text"
          value={formData.channeled_person.full_name}
          onChange={(e) => {
            onInputChange("channeled_person.full_name", e.target.value);
            if (fieldErrors.has("channeled_person.full_name")) {
              onFieldErrorRemove("channeled_person.full_name");
            }
          }}
          className={`form-input-compact w-full focus:outline-none transition-all duration-300 ${
            fieldErrors.has("channeled_person.full_name")
              ? "border-red-500 animate-pulse focus:border-red-600"
              : "focus:border-[rgba(232,115,115,0.5)]"
          }`}
          placeholder={t(
            "step3.full_name.placeholder",
            "Digite o nome da pessoa..."
          )}
        />
        {fieldErrors.has("channeled_person.full_name") && (
          <div className="mt-1 flex items-center text-red-600 text-xs font-medium">
            <span className="mr-1">⚠️</span>
            {t("common.error.required", "Campo obrigatório")}
          </div>
        )}
      </div>

      <div className="bg-white/40 rounded-lg p-3 border border-[rgba(232,115,115,0.15)]">
        <p className="form-description-text">
          {t(
            "step3.tip.text",
            "✨ Não se preocupe: apenas o primeiro nome já é suficiente para direcionar a leitura."
          )}
        </p>
      </div>
    </div>
  );
}
